import React from "react";
import { makeStyles } from "@material-ui/core";
import Typography from "../../shared/components/Typography";

const useStyles = makeStyles((theme) => ({
  root: { marginBottom: theme.spacing(1) },
}));

function ListItem(props: any) {
  const classes = useStyles();

  return (
    <Typography
      variant="body1"
      color="textPrimary"
      component="li"
      className={classes.root}
      {...props}
    />
  );
}

export default ListItem;
